import React, { useMemo } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { getIntlLinks } from '../../redux/selectors';
const createExternalLinkFormatter = path => chunks => /*#__PURE__*/React.createElement(Link, {
  to: path,
  className: "rich-link",
  target: "_blank",
  rel: "noopener noreferrer"
}, chunks);
const createInternalLinkFormatter = path => chunks => /*#__PURE__*/React.createElement(Link, {
  to: path,
  className: "rich-link"
}, chunks);
const FormattedRichMessage = ({
  id,
  values
}) => {
  const intl = useIntl();
  const activeLocale = intl.locale;
  const linksFromStore = useSelector(state => getIntlLinks(state, activeLocale));
  const formatValues = useMemo(() => {
    var _intl$messages;
    const message = (_intl$messages = intl.messages) === null || _intl$messages === void 0 ? void 0 : _intl$messages[id];
    if (!message) {
      return values;
    }
    const tagRegex = /<(\w+)>/g;
    const foundTags = new Set(Array.from(message.matchAll(tagRegex), match => match[1]));
    const dynamicLinkMap = {};
    foundTags.forEach(tag => {
      if (tag === 'emailPref') {
        dynamicLinkMap[tag] = createInternalLinkFormatter('/ipp');
        return;
      }
      const path = typeof (linksFromStore === null || linksFromStore === void 0 ? void 0 : linksFromStore.get) === 'function' ? linksFromStore.get(tag) : linksFromStore === null || linksFromStore === void 0 ? void 0 : linksFromStore[tag];
      if (path) {
        dynamicLinkMap[tag] = createExternalLinkFormatter(path);
      } else if (tag === 'bold') {
        dynamicLinkMap[tag] = chunks => /*#__PURE__*/React.createElement("strong", null, chunks);
      } else if (tag === 'italic') {
        dynamicLinkMap[tag] = chunks => /*#__PURE__*/React.createElement("em", null, chunks);
      } else if (tag === 'br') {
        dynamicLinkMap[tag] = () => /*#__PURE__*/React.createElement("br", null);
      } else if (tag === 'addressColumns') {
        dynamicLinkMap[tag] = chunks => /*#__PURE__*/React.createElement("span", {
          style: {
            display: 'inline-flex',
            width: '100%',
            gap: '24px',
            alignItems: 'flex-start',
            verticalAlign: 'top',
            marginTop: '8px'
          }
        }, chunks);
      } else if (tag === 'addressCol') {
        dynamicLinkMap[tag] = chunks => /*#__PURE__*/React.createElement("span", {
          style: {
            display: 'inline-block',
            flex: '1 1 0',
            minWidth: 0
          }
        }, chunks);
      } else if (tag === 'ul') {
        dynamicLinkMap[tag] = chunks => /*#__PURE__*/React.createElement("ul", null, chunks);
      } else if (tag === 'li' || tag.startsWith('li')) {
        // Support <li> as well as <li1>, <li2>, etc.
        dynamicLinkMap[tag] = chunks => /*#__PURE__*/React.createElement("li", null, chunks);
      } else {
        // Fallback for any other rich text tags
        dynamicLinkMap[tag] = chunks => chunks;
      }
    });
    return {
      ...dynamicLinkMap,
      ...values
    };
  }, [intl.messages, id, values, linksFromStore]);
  return /*#__PURE__*/React.createElement(FormattedMessage, {
    id: id,
    values: formatValues
  });
};
FormattedRichMessage.defaultProps = {
  values: {}
};
export default FormattedRichMessage;